"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Body1: function() {
        return _Body1.Body1;
    },
    body1ClassNames: function() {
        return _useBody1Stylesstyles.body1ClassNames;
    }
});
const _Body1 = require("./Body1");
const _useBody1Stylesstyles = require("./useBody1Styles.styles");
